import { combineReducers } from 'redux'

import isTimelineOpen from './isTimelineOpen'
import pagesList from './pagesList'

export default combineReducers({
  isTimelineOpen,
  pagesList,
})
